import { ColumnDef } from "@tanstack/react-table";
import type { EnrichedIcmStatement } from "@/icm/types";

const PlanNameCol: ColumnDef<EnrichedIcmStatement, unknown> = {
  accessorKey: "plan_name",
  header: "Plan",
  meta: { size: "120px" },
  cell: ({ getValue }) => (getValue() as string | null) ?? "-",
};

export default PlanNameCol;
